import React, { memo } from 'react';
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import { Tooltip } from "@mui/material";
import { round } from "../../SuskaiciuotasAtsakymas";
import { QUESTIONS_WITHOUT_SCORES } from '../constants';
import '../styles.css';

const QuestionScore = memo(({ name, score }) => {
    const { t } = useTranslation();
    
    if (QUESTIONS_WITHOUT_SCORES.includes(name)) return null;
    
    const formattedScore = !isNaN(score) ? round(score, 0.5) : '0';
    const tooltipTitle = t('is_10_galimu');
    
    return (
        <div 
            className="Balas row verticalCenter mobRezAts"
            role="region" 
            aria-label={`${t('balas')} ${formattedScore}`}
        >
            <Box 
                component="span"
                sx={{ 
                    typography: 'body2',
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                    mr: 1
                }} 
                className="text"
            >
                {t('balas')}:
            </Box>
            <Tooltip 
                title={tooltipTitle}
                placement="top"
                arrow
            >
                <div 
                    className="rezultataiAts"
                    role="status"
                    aria-label={tooltipTitle}
                >
                    {formattedScore}
                </div>
            </Tooltip>
        </div>
    );
});

QuestionScore.displayName = 'QuestionScore';

export default QuestionScore;
